
  import { css } from 'lit';
  export const styles = css`igc-button::part(focused),igc-button::part(focused):hover{box-shadow:0 0 0 .25rem var(--button-focus-border-color);border-color:var(--button-border-color)}:host igc-button::part(base):active{--active-foreground: var-get($theme, "button-hover-arrow-color")}`;
  